import { FormEvent, useEffect, useState } from 'react';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Panel, Row, Well } from 'react-bootstrap';

interface IProps {
    isChainEnd: boolean,
    requireEplet: number,
    cmvPreference: number,
    ebvPreference: number,
    requirePreselect: number,
    expectedWaitTimeLowEmm: number,
    screeningComments: string,
    histogeneticsRawTypingFile: string,
    onChange: (name: string, value: any) => void,
    onReview: () => void,
    onSave: () => void
}

const RecipientPreferences = (props: IProps) => {
    const [notifyEpletMMTime, setEpletMMNotification] = useState<boolean>(false);

    useEffect(() => {
        if (props.expectedWaitTimeLowEmm >= 4) {
            setEpletMMNotification(true)
        }
    }, []);


    const handleFieldChange = (e: FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { name, value } = e.currentTarget;
        props.onChange(name, value);
    };

    return (
        <Panel>
            <Panel.Heading>
                Modify Donor Preferences (to see how they impact their matching power {props.isChainEnd ? <>(cPRA &lt; 99 only)</> : null})
            </Panel.Heading>
            <Panel.Body>
                {notifyEpletMMTime && (
                    <Alert bsStyle='warning' bsSize='sm'>
                        <p>
                            The Eplet Mismatch Calculator indicates that your patient cannot get a low eplet MM in &lt;= 4 months
                        </p>
                        <p>
                            <Button bsSize='xs' onClick={() => setEpletMMNotification(false)}> Dismiss </Button>
                        </p>
                    </Alert>
                )}

                <Form inline style={{ marginBottom: 15 }}>
                    {props.histogeneticsRawTypingFile.length > 5 && (
                        <FormGroup style={{ marginRight: 25 }}>
                            <ControlLabel>Eplet MM:&nbsp;</ControlLabel>
                            <FormControl
                                componentClass='select'
                                name='requireEplet'
                                value={props.requireEplet}
                                onChange={handleFieldChange}
                            >
                                <option value={-1}>Unknown</option>
                                <option value={0}>Any</option>
                                <option value={2}>Low</option>
                            </FormControl>
                        </FormGroup>
                    )}

                    <FormGroup style={{ marginRight: 25 }}>
                        <ControlLabel>CMV:&nbsp;</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='cmvPreference'
                            value={props.cmvPreference}
                            onChange={handleFieldChange}
                        >
                            <option value={0}>Unknown</option>
                            <option value={1}>Any</option>
                            <option value={2}>Positive</option>
                            <option value={3}>Negative</option>
                        </FormControl>
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>EBV:&nbsp;</ControlLabel>
                        <FormControl
                            componentClass='select'
                            name='ebvPreference'
                            value={props.ebvPreference}
                            onChange={handleFieldChange}
                        >
                            <option value={0}>Unknown</option>
                            <option value={1}>Any</option>
                            <option value={2}>Positive</option>
                            <option value={3}>Negative</option>
                        </FormControl>
                    </FormGroup>
                </Form>

                <FormGroup>
                    <ControlLabel className='bold'>Screening Comments:</ControlLabel>
                    <FormControl
                        componentClass='textarea'
                        name='screeningComments'
                        value={props.screeningComments}
                        maxLength={500}
                        rows={5}
                        style={{ resize: 'none', width: '100%' }}
                        onChange={handleFieldChange}
                    />
                    <HelpBlock style={{ textAlign: 'right' }}>500 characters max</HelpBlock>
                </FormGroup>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button style={{ width: 200 }} onClick={props.onReview}>Review Pre-Selects</Button>
                    <Button bsStyle='primary' style={{ width: 200 }} onClick={props.onSave}>Save Preferences</Button>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default RecipientPreferences;